export default "__VITE_ASSET__D7Zt7xHb__"